import { DataTable, type ColumnDef, type ItemProps } from "@repo/ui";
import { cn } from "@repo/utils";
import type { TaskManagerDTO } from "~/types/api-custom";
import type { TaskActionsContext } from "./brand-row";

type Props = {
  isLoading: boolean;
  tasks: TaskManagerDTO[];
  columns: ColumnDef<TaskManagerDTO>[];
  actions: ItemProps<TaskActionsContext>[];
  searchQuery: string;
  showAll: boolean;
};

export const BrandRowBody = ({
  isLoading,
  tasks,
  columns,
  actions,
  searchQuery,
  showAll,
}: Props) => {
  return (
    <div className={cn("border-t border-gray-200", { "py-4": !tasks.length })}>
      {isLoading ? (
        <div className="py-8 text-center text-gray-500">Loading tasks...</div>
      ) : tasks.length > 0 ? (
        <DataTable<TaskManagerDTO, TaskActionsContext>
          data={tasks}
          columns={columns}
          actions={actions}
          headerClassName="border-b mx-2 border-gxe-border"
          rowClassName="px-2"
          bodyClassName="!border-none"
        />
      ) : (
        <div className="py-8 text-center text-gray-500">
          {searchQuery || !showAll
            ? "No tasks match your criteria"
            : "No tasks found for this brand"}
        </div>
      )}
    </div>
  );
};
